__turbopack_context__.v({
  "search": "DocumentationSearch-module__6ImA2q__search",
});
